import { Link } from 'react-router-dom';
import { useState } from 'react';
import LogoMini from '../assets/logo-mini.svg';
import { HamburgerMenu } from '../components/HamburgerMenu/HamburgerMenu';
import { Sidebar } from '../components/Sidebar/Sidebar';

export function Header() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 bg-white z-40 border-b border-gray-300">
        <div className="max-w-[1440px] m-auto h-[60px] items-center flex px-2 lg:px-6 py-2 gap-2 justify-between">
          <Link to="/sample">
            <img
              src={LogoMini}
              alt="Logo-mini"
              width={36}
              className="grayscale lg:hover:grayscale-0 lg:hover:scale-105 transition-all duration-300"
            />
          </Link>
          <div>
            <HamburgerMenu isOpen={isSidebarOpen} onToggle={toggleSidebar} />
          </div>
        </div>
      </header>

      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
    </>
  );
}

export default Header;
